/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'logs-search-bar';
const prefix = `${moduleName}.${componentName}`;

export const filterPlaceholder = `${prefix}.filterPlaceholder`;
export const logCount = `${prefix}.logCount`;

export const ENGLISH = {
    [logCount]: '{0, plural, one{# Log} other{# Logs}}',
    [filterPlaceholder]: 'Filter by Name, Path, or more',
};
